import { Component } from '@angular/core';

@Component({
  selector: 'zx-layout-blank',
  template: '<router-outlet></router-outlet>'
})
export class BlankComponent {
    constructor() { }
}